<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" lang="en" xml:lang="en">
  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="x-apple-disable-message-reformatting" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <title></title>

    <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500&display=swap" rel="stylesheet" />
  </head>

  <body class="clean-body u_body">
    <table id="u_body" class="u_body_table" aria-describedby="u_body_table">
      <thead>
        <tr style="vertical-align: middle;">
          <th class="u_body_td">
            <div class="u-row-container">
              <div class="u-row">
                <div class="u-row_sub">
                  <div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;">
                    <div style="height: 100%;width: 100% !important;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;">
                      <div class="u-row-sub1">
                        <table class="table_font" id="u_content_text_6" aria-describedby="table_font">
                          <thead>
                            <tr>
                              <th style="padding-top: 10%;"></th>
                            </tr>
                          </thead>
                        </table>
                        <table *ngIf="isCustomer()" id="u_content_heading_2" class="table_font" aria-describedby="u_content_heading_2" >
                          <thead>
                            <tr>
                              <th class="v-container-padding-padding">
                                <span class="image-container"><img src="assets/account.svg" alt="user-account-image" /></span>
                                <h1 class="v-font-size">Account successfully Created</h1>
                              </th>
                            </tr>
                          </thead>
                        </table>


                        <table *ngIf="isCustomer()" id="u_content_text_2" aria-describedby="u_content_text_2">
                          <thead>
                            <tr>
                              <th class="v-container-padding-padding2">
                                <div style="line-height: 180%; text-align: left; word-wrap: break-word;">
                                  <p>Please continue with app again !</p>
                                </div>
                              </th>
                            </tr>
                          </thead>
                        </table>


                        <table *ngIf="isCustomer()" id="u_content_button_4" class="table_font" aria-describedby="u_content_button_4">
                          <thead>
                            <tr>
                              <th class="v-container-padding-padding3">
                                <div>
                                  <a href="{{appRedirectionLink}}" target="_self" class="v-button v-size-width"><strong>Get started with app</strong></a>
                                </div>
                              </th>
                            </tr>
                          </thead>
                        </table>
                        <table *ngIf="!isCustomer()" id="u_content_heading_2" class="table_font" aria-describedby="u_content_heading_2" >
                          <thead>
                            <tr>
                              <th class="v-container-padding-padding">
                                <span class="image-container"><img src="assets/account.svg" alt="user-account-image" /></span>
                                <h1 class="v-font-size">Account Under Review</h1>
                              </th>
                            </tr>
                          </thead>
                        </table>


                        <table *ngIf="!isCustomer()" id="u_content_text_2" aria-describedby="u_content_text_2">
                          <thead>
                            <tr>
                              <th class="v-container-padding-padding2">
                                <div style="line-height: 180%; text-align: left; word-wrap: break-word;">
                                  <p>You will receive an email once your account is reviewed in the next 24 hours.</p>
                                </div>
                              </th>
                            </tr>
                          </thead>
                        </table>

                        <table id="u_content_text_6" class="table_font" aria-describedby="u_content_text_6">
                          <thead>
                            <tr>
                              <th style="height: 100px;"></th>
                            </tr>
                          </thead>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </th>
        </tr>
      </thead>
    </table>
  </body>
</html>